import React from "react";
import {
  IonBackdrop,
  IonButton,
  IonCheckbox,
  IonContent,
  IonIcon,
  IonPage,
  IonText,
} from "@ionic/react";
import { alertCircleOutline, refresh } from "ionicons/icons";
import LogoutButton from "../../../components/helpers/LogoutButton";

type OneErrorBackdropProps = {
  errorMsg: string;
};
const OneErrorBackdrop: React.FC<OneErrorBackdropProps> = ({ errorMsg }) => {
  return (
    <>
      <IonPage>
        <IonContent>
          <IonBackdrop visible={true} style={{ opacity: 0.25 }}></IonBackdrop>
          <div id="box">
            <IonIcon icon={alertCircleOutline} color="danger" size="large" />
            <IonText color="danger">
              <p className="ion-text-center ion-no-margin">
                {errorMsg || `Oops! Something went wrong.`}
              </p>
            </IonText>
            <LogoutButton />
          </div>
        </IonContent>
      </IonPage>
    </>
  );
};

export default OneErrorBackdrop;
